// Currently a copy of EventContent. Update with Fundraiser-specific components.

import React, { useMemo } from "react";
import {
  Event as EventType,
  Community,
  OrgBootstrap,
} from "@dreambigger/shared/src/types";
import {
  Card,
  Group,
  ShareBar,
  DecoratedImage,
} from "@dreambigger/design-system";
type FundraiserContentProps = {
  event: EventType;
  orgBootstrap: OrgBootstrap;
  community: Community;
  coverImage: string;
};

const FundraiserContent = ({ event, coverImage }: FundraiserContentProps) => {
  // -------- Main Header ------------
  const MainContentHeaderComponent = useMemo(() => {
    if (!event) return;
    return (
      <>
        <DecoratedImage
          src={coverImage}
          alt="Event Img"
          cornerButtonEnabled={true}
          cornerButtonText="Edit"
          cornerButtonTextExpanded="Edit Image"
          cornerButtonIcon="images"
          style={{
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            boxShadow: "rgb(0 0 0 / 16%) 0px 1px 4px",
          }}
        />
      </>
    );
  }, [event]);

  // --------- Share ------------------
  const ShareComponent = useMemo(() => {
    if (!event) return;
    return (
      <>
        <style>
          @import
          url('https://fonts.googleapis.com/css2?family=The+Girl+Next+Door&display=swap');
        </style>
        <h3
          className="pv-3 mb-0 f-4 sm_f-5 md_f-7"
          style={{
            textAlign: "center",
            fontWeight: "bold",
            marginBottom: "20px",
            fontFamily: "The Girl Next Door",
            color: "darkgray",
          }}
        >
          Help spread the word!
        </h3>
        <div className="w-100 md_w-80 lg_w-70 xl_w-60 self-center">
          {/* ShareBar at non-mobile sizes */}
          <div className="dn md_db">
            <ShareBar
              labeledButtons={true}
              liftOnHover={true}
              rectangularButtons={true}
              clipboard={false}
            />
          </div>
          {/* ShareBar at mobile sizes */}
          <div className="w-50 md_dn mh-auto">
            <ShareBar
              rectangularButtons={true}
              clipboard={false}
              liftOnHover={true}
            />
          </div>
        </div>
      </>
    );
  }, [event]);

  // --------- Description --------------
  const MainContentDescription = useMemo(() => {
    if (!event) return;
    return (
      <Card
        className="mt-5"
        style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px" }}
      >
        <h3 className="fwb">About {event.name}</h3>
        <p className="mb-0" style={{ whiteSpace: "pre-line" }}>
          {event.description}
        </p>
      </Card>
    );
  }, [event]);

  // --------- User Actions -------------
  const UserActionsMenu = useMemo(() => {
    return <div>User Actions Menu</div>;
  }, []);

  // --------- Latest Donations ---------
  const LatestDonations = useMemo(() => {
    return <div>Latest Donations</div>;
  }, []);

  // **************************************************************
  // * RENDER THE VIEW
  // **************************************************************
  return (
    <>
      <Group md="horizontal" spacing={5} style={{ minHeight: "600px" }}>
        {/* LEFT COLUMN */}
        <Group className="md_w-66">
          {MainContentHeaderComponent}
          {ShareComponent}
          {MainContentDescription}
        </Group>
        {/* RIGHT COLUMN */}
        <Group
          className="md_w-33 pl-5"
          style={{ border: "dashed orange 1px br-2" }}
        >
          {UserActionsMenu}
          {LatestDonations}
        </Group>
      </Group>
      {/* {eventStories && <div>Stories found! Display all stories here.</div>}
      {!eventStories && <div>No stories found! Display "add Story Cta"</div>} */}
    </>
  );
};

export default FundraiserContent;
